import React from 'react';

const CustomMessage = () => {
  return (
    <p>Je n'ai pas bien compris, pourriez vous reformuler</p>
  );
};

export default CustomMessage;